<!--
/*******************************************************************************
*@ 컴포넌트명   : PersonalInfo1.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 수정 [개인]
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="corporation">
    <div class="scroll">
      <contents-header :bg-type="true" title="MPRS-01-01-03-01" />
      <article class="contents">
        <template v-if="siteCode === $config.SITECODE_OGAUC || siteCode === $config.SITECODE_OGIND">
          <!--
            MPRS-01-01-03-02 : 기본정보
          -->
          <tab ref="perInfoTab" css-type="type3" :title-list="['MPRS-01-01-03-02']">
            <template #0>
              <personalInfoTab1 ref="tab1" :data.sync="perInfo" />
            </template>
          </tab>
        </template>
        <template v-else>
          <!--
            MPRS-01-01-03-02 : 기본정보
            MPRS-01-01-03-03 : 자택주소
            MPRS-01-01-03-04 : 회사주소
          -->
          <tab
            ref="perInfoTab"
            css-type="type3"
            :title-list="['MPRS-01-01-03-02', 'MPRS-01-01-03-03', 'MPRS-01-01-03-04']"
          >
            <template #0>
              <personalInfoTab1 ref="tab1" :data.sync="perInfo" />
            </template>
            <template #1>
              <personalInfoTab2 ref="tab2" :data.sync="perInfo" />
            </template>
            <template #2>
              <personalInfoTab3 ref="tab3" :data.sync="perInfo" />
            </template>
          </tab>
        </template>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md gray" @click="goPrevStep">{{ /*취소*/ $t("MCOM-0000002") }}</button>
      <button class="btn md normal" @click="goNextStep">{{ /*수정*/ $t("MPRS-01-01-03-11") }}</button>
    </div>
  </section>
</template>
<script>
import personalInfoTab1 from "@/components/page/admin/PersonalInfoTab1";
import personalInfoTab2 from "@/components/page/admin/PersonalInfoTab2";
import personalInfoTab3 from "@/components/page/admin/PersonalInfoTab3";
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";
import { required } from "vuelidate/lib/validators";

export default {
  extends: Common,
  components: {
    personalInfoTab1,
    personalInfoTab2,
    personalInfoTab3,
  },
  validations: {
    RBF0409E40_data: {
      // 휴대폰 번호
      cphnNo: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          if (this.siteCode === this.$config.SITECODE_OGHCM) return true;
          if (this.siteCode === this.$config.SITECODE_OGCBD) return true;
          return required(paramObj.cphnNo);
        },
      },
      // 이메일 주소
      emad1: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGCBD) return true;
          if (this.siteCode === this.$config.SITECODE_OGHCM) return true;
          return required(paramObj.emad1);
        },
      },
      // 자택주소
      owhusAddr1: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          if (this.siteCode === this.$config.SITECODE_OGAUC) return true;
          return required(paramObj.owhusAddr1);
        },
      },
      // 회사주소
      coAddr1: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          if (this.siteCode === this.$config.SITECODE_OGAUC) return true;
          if (paramObj.postSendAreaDstcd === "3") return true;
          return required(paramObj.coAddr1);
        },
      },
      // 우편물 수신
      postSendAreaDstcd: {
        required: function (val, paramObj) {
          if (this.siteCode === this.$config.SITECODE_OGIND) return true;
          return required(paramObj.postSendAreaDstcd);
        },
      },
      // 거래 Statement 우편발송 여부
      postSendYn: {
        required: function (val, paramObj) {
          if (this.siteCode !== this.$config.SITECODE_OGAUC) return true;
          return required(paramObj.postSendYn);
        },
      },
      // Statement 우편수신서비스 신청
      isPostSendYnAgree: {
        required: function (val, paramObj) {
          if (this.siteCode !== this.$config.SITECODE_OGAUC) return true;
          if (this.RBF0409E40_data.postSendYn !== "1") return true;

          const isPostSendYnAgree = paramObj.isPostSendYnAgree === true;
          return required(isPostSendYnAgree ? isPostSendYnAgree : undefined);
        },
      },
    },
  },
  computed: {
    ...mapFields("admin/personalInfo", ["RBF0409E40", "RBF0409E40_data"]),
  },
  data() {
    return {
      perInfo: {},
    };
  },
  created() {
    if (Object.entries(this.RBF0409E40_data).length === 0) {
      this.perInfo = _.cloneDeep(this.RBF0409E40);
    } else {
      this.perInfo = _.cloneDeep(this.RBF0409E40_data);
    }
  },
  methods: {
    goPrevStep() {
      this.$router.push({ name: "perInfo" });
    },
    goNextStep() {
      this.RBF0409E40_data = this.perInfo;

      if (!_.isEmpty(this.perInfo.emailId) || !_.isEmpty(this.perInfo.emailAddress)) {
        this.RBF0409E40_data.emad1 = this.perInfo.emailId + "@" + this.perInfo.emailAddress;
      } else {
        this.RBF0409E40_data.emad1 = "";
      }

      const currentTab = this.$refs.perInfoTab.currentTab;

      if (currentTab == "0") {
        this.$refs.tab1.touch();
      } else if (currentTab == "1") {
        this.$refs.tab2.touch();
      } else if (currentTab == "2") {
        this.$refs.tab3.touch();
      }

      if (this.$v.$invalid) {
        if (
          this.$v.RBF0409E40_data.cphnNo.$invalid ||
          this.$v.RBF0409E40_data.emad1.$invalid ||
          this.$v.RBF0409E40_data.postSendAreaDstcd.$invalid ||
          this.$v.RBF0409E40_data.postSendYn.$invalid ||
          this.$v.RBF0409E40_data.isPostSendYnAgree.$invalid
        ) {
          //기본정보
          this.changeTab("1");
        } else if (this.$v.RBF0409E40_data.owhusAddr1.$invalid) {
          //자택주소
          this.changeTab("2");
        } else if (this.$v.RBF0409E40_data.coAddr1.$invalid) {
          //회사주소
          this.changeTab("3");
        }

        return;
      }

      this.$router.push({ name: "perInfoStep2" });
    },
    async changeTab(tab) {
      /* tab: 1: 기본정보  2: 자택주소  3: 회사주소 */
      let newTab = 0;
      const oldTab = this.$refs.perInfoTab.currentTab;

      if (tab == "1") {
        //기본정보
        newTab = 0;
      } else if (tab == "2") {
        //자택주소
        if (this.siteCode === this.$config.SITECODE_OGAUC) newTab = null;
        else if (this.siteCode === this.$config.SITECODE_OGIND) newTab = null;
        else newTab = 1;
      } else if (tab == "3") {
        //회사주소
        if (this.siteCode === this.$config.SITECODE_OGAUC) newTab = null;
        else if (this.siteCode === this.$config.SITECODE_OGIND) newTab = null;
        else newTab = 2;
      }

      if (!_.isNil(newTab) && newTab != oldTab) {
        await this.$refs.perInfoTab.tabClick(newTab);

        if (tab == "1") this.$refs.tab1.touch();
        else if (tab == "2") this.$refs.tab2.touch();
        else if (tab == "3") this.$refs.tab3.touch();
      }
    },
  },
};
</script>
